import { addBookmark, deleteBookmark } from 'services/userService';
import userToolBoxJwt from 'hooks/useToolboxStorage';
import snackbar from 'utils/snackbar';

const nameCapitalized = name => name.charAt(0).toUpperCase() + name.slice(1);

const toggleBookmark = async (save, data, userInfo, setUserInfo, openLoginModal) => {
  const jwt = userToolBoxJwt.get();

  userInfo.bookmarks = userInfo.bookmarks || [];

  try {
    if (save) {
      await addBookmark(jwt, data);

      userInfo.bookmarks.push(data);

      const dataLayerData = {
        event: 'bookmark saved',
        email: userInfo.email,
        bookmark_path: data.url,
        bookmark_title: data.title,
        bookmark_type: data.type,
      };

      dataLayer.push(dataLayerData);

      snackbar(`Bookmark Added: ${nameCapitalized(data.type)}: ${data.title}`);
    } else {
      await deleteBookmark(jwt, data);

      userInfo.bookmarks.splice(
        userInfo.bookmarks.findIndex(x => x.url === data.url),
        1
      );

      snackbar(`Bookmark Removed: ${nameCapitalized(data.type)}: ${data.title}`);

      const dataLayerData = {
        event: 'bookmark removed',
        email: userInfo.email,
        bookmark_path: data.url,
        bookmark_title: data.title,
        bookmark_type: data.type,
      };

      dataLayer.push(dataLayerData);
    }
  } catch (e) {
    if (e?.response?.data?.error?.toLowerCase() === 'jwt is expired') {
      openLoginModal();
    }
  }

  setUserInfo({ ...userInfo });
};

export default toggleBookmark;
